import { Component, OnInit } from '@angular/core';
import { I18nService } from '@shared/services';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  constructor(
    private i18nService: I18nService,
  ) {}

  public ngOnInit(): void {
    this.i18nService.init();
  }
}
